import { ComponentResolver } from '../hybrid/component-resolver.js';
import { Component } from './component.js';

// Configure isomorphic resolver with client-specific dependencies
// Use property descriptors for observer/config — they aren't available yet at import time
ComponentResolver.Component = Component;
ComponentResolver.getStore = () => state;
Object.defineProperty(ComponentResolver, 'observer', { get: () => observer, configurable: true });
Object.defineProperty(ComponentResolver, 'config', { get: () => config, configurable: true });

export { ComponentResolver };
export default ComponentResolver;
